module.exports = __webpack_public_path__ + "img/qa2.3e4b2171.jpg";